var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"d-flex justify-center align-center",staticStyle:{"height":"100%"},attrs:{"cols":"12"}},[_c('i',{staticClass:"mdi mdi-lock-alert mdi-48px"}),_c('h1',[_vm._v(" You don’t have permission to view this page ")])])}
var staticRenderFns = []

export { render, staticRenderFns }